import type { TranslationInterface } from '.';

export const IcelandicLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Skrifaðu skilaboð...',
  your_issue_has_been_resolved: 'Málið þitt hefur verið leyst!',
  new_conversation: 'Nýtt samtal',
  welcome_screen_title: 'Velkomin í þjónustuverið okkar',
  welcome_screen_description:
    'Við erum hér til að hjálpa! Byrjaðu samtal og við munum svara eins fljótt og auðið er.',
  your_name_placeholder: 'Nafnið þitt',
  your_email_placeholder: 'Netfangið þitt',
  start_chat_button: 'Tala við þjónustuver',
  start_chat_button_loading: 'Tengist...',
  i_need_more_help: 'Ég þarf meiri hjálp',
  this_was_helpful: 'Þetta var gagnlegt',
  optional: 'Valfrjálst',
  no_conversations_yet: 'Engin samtöl ennþá',
  back_to_conversations: 'Til baka í samtöl',
  closed_conversations: 'Lokuð samtöl',
  csat_title: 'Hvernig var samtalið þitt?',
  csat_submitted_title: 'Þú gafst samtalinu einkunnina',
  csat_feedback_placeholder: 'Segðu okkur meira... (valfrjálst)',
  follow_up_placeholder: 'Spyrja nánar…',
  companion_layout_label: 'Útlit',
  companion_layout_floating: 'Fljótandi',
  companion_layout_sidebar: 'Hliðarstika',
  companion_layout_fullscreen: 'Allur skjárinn',
  companion_close: 'Loka',
  companion_history: 'Samtalaferill',
  companion_expand_chat: 'Stækka spjall',
  companion_sidebar_dock_label: 'Kví',
  companion_sidebar_side_label: 'Hlið',
  companion_sidebar_left: 'Vinstri',
  companion_sidebar_right: 'Hægri',
  companion_resize_chat: 'Breyta stærð spjalls',
  scroll_to_bottom: 'Fara neðst',
  thinking: 'Hugsa…',
  running: 'Í vinnslu…',
  steps: 'skref',
  step_arguments: 'Viðföng',
  step_result: 'Niðurstaða',
  attach_files:
    'Hengja við myndir, myndskeið, PDF-skjöl eða töflureikna (hámarksstærð 25 MB)',
  mark_page_active:
    'Smelltu á eitthvað á síðunni til að merkja það — Esc til að hætta við',
  mark_page: 'Merktu eitthvað á síðunni til að spyrja um það',
  stop_response: 'Stöðva svar',
  copy_reply: 'Afrita svar',
  mentions_empty: 'Engar niðurstöður',
  copied: 'Afritað',
  send_message: 'Senda skilaboð',
  upload_failed: 'Upphleðsla mistókst: {error}',
  remove_attachment: 'Fjarlægja viðhengi',
  json_no_items: 'Engin atriði',
  json_no_data: 'Engin gögn',
  json_no_chart_data: 'Engin gögn fyrir myndrit',
  json_unsupported: 'Ekki stutt: {type}',
  json_see_less: 'Sýna minna',
  json_phone_agent: 'Símafulltrúi',
  json_phone_agent_test: 'Prófa á vefnum',
  page_context_remove: 'Fjarlægja samhengi síðu',
  json_see_more: 'Sýna {count} í viðbót',
  queued_label: '{count} Í biðröð',
  remove_queued_message: 'Fjarlægja skilaboð úr biðröð',
  send_queued_now: 'Senda skilaboð í biðröð núna',
  turn_failed_message: 'Eitthvað fór úrskeiðis og svarið barst ekki.',
  turn_failed_retry: 'Reyna aftur',
  page_mark_hint: 'Smelltu á eitthvað til að merkja það',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Rammi',
  page_mark_shape_circle: 'Hringur',
  page_mark_shape_arrow: 'Ör',
  page_mark_shape_bracket: 'Hornklofi',
  page_mark_shape_underline: 'Undirstrikun',
  page_mark_shape_highlight: 'Áherslulitun',
  page_mark_shape_strike_through: 'Yfirstrikun',
  page_mark_shape_crossed_off: 'Krossa yfir',
  page_mark_shape_aria: 'Lögun merkingar: {shape}',
  page_mark_note_placeholder: 'Bæta við athugasemd… (Enter til að hengja við)',
  page_mark_attach: 'Hengja merkingu við',
  page_mark_remove: 'Fjarlægja {label}',
  page_mark_region: 'Merkt svæði',
  page_mark_default_message: 'Hvað er þetta?',
  file_rejected: 'Skráargerðin er ekki studd eða skráin er of stór.',
  dictate: 'Lesa fyrir',
  stop_dictation: 'Hætta að lesa fyrir',
  dictation_mic_blocked: 'Leyfðu aðgang að hljóðnema til að lesa fyrir',
  dictation_unavailable: 'Fyrirlestur er ekki í boði núna',
  questions_back: 'Til baka',
  questions_next: 'Áfram',
  questions_send: 'Senda',
  questions_type_answer: 'Ég skrifa það',
  questions_answer_placeholder: 'Skrifaðu svarið þitt…',
  close_conversation_title: 'Loka samtali',
  close_conversation_description:
    'Ertu viss um að þú viljir loka þessu samtali?',
  close_conversation_cancel: 'Nei',
  close_conversation_confirm: 'Já',
  dialog_close: 'Loka',
  zoom_in: 'Auka aðdrátt',
  zoom_out: 'Minnka aðdrátt',
  reset_zoom: 'Endurstilla aðdrátt',
  support_chat_aria_label: 'Þjónustuspjall',
};
